import { IDomain } from "common/models/userInfo";
import { IFavorite } from "common/types";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { IApplicationState } from "../../redux/root-reducer";
import { INode } from "../../search/types";
import { setFavorites } from "../common.actions";
import { ReactComponent as FavoriteLogo } from "../icons/star.svg";
import styles from "./Favorite.module.scss";

export interface IFavoriteProps {
  selectedNode: INode;
}

const savedSelector = (selectedNode: INode, selectedDomain: IDomain) =>
  createSelector(
    (state: IApplicationState) => state.common.favorites,
    (favorites) =>
      favorites.find(
        (f) =>
          f.node.ID === selectedNode?.ID &&
          f.domain.Name === selectedDomain?.Name
      )
        ? true
        : false
  );

export const Favorite = ({ selectedNode }: IFavoriteProps) => {
  const dispatch = useDispatch();
  const selectedDomain = useSelector(
    (state: IApplicationState) => state.common.selectedDomain
  );
  const saved = useSelector(savedSelector(selectedNode, selectedDomain!));

  const handleClicked = () => {
    const favorite: IFavorite = { domain: selectedDomain!, node: selectedNode };
    dispatch(setFavorites(favorite));
  };

  return (
    <div onClick={() => handleClicked()}>
      <FavoriteLogo
        height={16}
        width={16}
        className={saved ? styles.favorite : styles.notFavorite}
      />
    </div>
  );
};
